const url = "/api/v1/newsletter_registrations";

export interface NewsletterRegistrationsCreateParams {
  email: string;
}

export const newsletterRegistrationsCreateQuery = (
  params: NewsletterRegistrationsCreateParams,
) => ({
  url,
  method: "POST",
  body: params,
});
